'use client';

import { Spacing } from '@kezios/design-system';
import { Stack } from '@mantine/core';

import css from './HomePageLayout.module.css';

export const HomePageLayout = ({ children }) => {
  return (
    <Stack gap={Spacing.s24} pb={Spacing.s24} className={css.container}>
      {children}
    </Stack>
  );
};
